// extracted by mini-css-extract-plugin
export default {"moreApplications":"CandidatesList-ApplicationsWithPopover__moreApplications--IAktA"};